import React, { useState } from "react";
import { FiMail, FiPhone, FiSend, FiUser } from "react-icons/fi";
import { HiOutlinePencilAlt } from "react-icons/hi";
import "./ContactPage1.css";

const ReachOutForm = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = ({ target: { id, value } }) => {
    setForm((previous) => ({ ...previous, [id]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    try {
      const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");
      const contactEndpoint = API_URL.endsWith("/api")
        ? `${API_URL}/contact-data`
        : `${API_URL}/api/contact-data`;

      const response = await fetch(contactEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!response.ok) throw new Error("Failed to send message");

      setSuccessMessage("Your message has been sent successfully!");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      console.error(error);
      setSuccessMessage("Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
      window.setTimeout(() => setSuccessMessage(""), 5000);
    }
  };

  return (
    <div className="contact-card contact-form-card">
      <h2 className="contact-card-title"><FiSend /> Send us a Message</h2>
      <form className="reference-contact-form" onSubmit={handleSubmit}>
        <div className="contact-fields-column">
          <label className="contact-field" htmlFor="name">
            <span className="contact-field-label"><FiUser /> Full Name <b>*</b></span>
            <span className="contact-input-wrap"><FiUser /><input id="name" type="text" placeholder="Enter your name" required value={form.name} onChange={handleChange} /></span>
          </label>

          <label className="contact-field" htmlFor="email">
            <span className="contact-field-label"><FiMail /> Email Address <b>*</b></span>
            <span className="contact-input-wrap"><FiMail /><input id="email" type="email" placeholder="Enter your email" required value={form.email} onChange={handleChange} /></span>
          </label>

          <label className="contact-field" htmlFor="phone">
            <span className="contact-field-label"><FiPhone /> Phone Number</span>
            <span className="contact-input-wrap"><FiPhone /><input id="phone" type="tel" placeholder="Enter your phone number" value={form.phone} onChange={handleChange} /></span>
          </label>

          <button className="contact-submit" type="submit" disabled={submitting}>
            <FiSend /> {submitting ? "Submitting..." : "Submit Message"}
          </button>
        </div>

        <label className="contact-field contact-message-field" htmlFor="message">
          <span className="contact-field-label"><HiOutlinePencilAlt /> Your Message <b>*</b></span>
          <textarea id="message" placeholder="Type your message here..." required value={form.message} onChange={handleChange} />
        </label>
      </form>
      {successMessage && <div className="contact-status" role="status">{successMessage}</div>}
    </div>
  );
};

export default ReachOutForm;
